export default __webpack_public_path__ + "static/media/agent_red.59d4e0d6.svg";